export default __webpack_public_path__ + "fonts/tired-landlords.svg";